/* DemoFillButton — Small "Fill demo" affordance for the case-submission
 * wizard. Lives at the top-right of each wizard step body (next to the
 * step hero) so the visiting doctor can rapidly populate a step with
 * realistic clinical data when we're showing the platform.
 *
 * The scenario rotates across wizard sessions — the wizard mounts with
 * the NEXT scenario in the localStorage cycle so two consecutive demos
 * (e.g. demoing to two doctors back-to-back) don't show identical data.
 *
 * iter98.99bn
 * iter98.99dd — Removed the scenario-rotation dots + "#N" suffix per
 *   user direction (visual clutter on the Review step). The scenario
 *   still rotates under the hood — the button just doesn't advertise it.
 */
import React, { useState } from "react";
import { Sparkle, Spinner } from "@phosphor-icons/react";


export default function DemoFillButton({
    stepLabel,
    scenarioLabel,
    scenarioIdx,
    onFill,
    disabled = false,
    testId = "demo-fill-btn",
}) {
    const [busy, setBusy] = useState(false);
    const handleClick = async () => {
        if (busy || disabled) return;
        setBusy(true);
        try {
            await onFill();
        } finally {
            setBusy(false);
        }
    };
    return (
        <div className="flex items-center gap-2 shrink-0" data-testid={testId}>
            <button
                type="button"
                onClick={handleClick}
                disabled={busy || disabled}
                className="inline-flex items-center gap-1.5 px-3 h-8 rounded-full text-[11.5px] font-semibold border border-dashed border-primary/40 text-primary/90 hover:bg-primary/5 hover:border-primary/70 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                data-testid={`${testId}-action`}
                title={`Fill ${stepLabel} with demo data${scenarioLabel ? ` — ${scenarioLabel}` : ""}`}
            >
                {busy ? (
                    <Spinner size={11} className="animate-spin" />
                ) : (
                    <Sparkle size={11} weight="fill" className="text-amber-500" />
                )}
                {busy ? "Filling…" : `Fill ${stepLabel}`}
            </button>
        </div>
    );
}
